<template>
	<AppDialog closeRight="-10" closeTop="-30" ref="dialog_container" :dialogName="'ContinueInstallationSignupDialog'">
		<div class="content-container flex-column flex-centerize">
			<div class="title-text">Pending installation</div>
			<div class="title-description-text mt-1 mb-9">You've started installing this feature. Do you want to continue?</div>
			<InstallablePreview class="width-100 px-6 mb-4" :installableId="installableId" />
			<AnemicButton @click="continueInstallation" class="mt-9 continue-button">Continue with installation</AnemicButton>
			<div class="divider-container display-flex width-100 flex-row flex-align-center px-1 my-4">
				<div class="divider width-100"></div>
				<div class="divider-text mx-2">or</div>
				<div class="divider width-100"></div>
			</div>
			<AnemicButton @click="dismissInstallation" class="dismiss-button">Continue without installation</AnemicButton>
		</div>
	</AppDialog>
</template>

<script>
import InstallablePreview from '@/components/Project/InstallablePreview.vue';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';

export default {
	name: 'ContinueInstallationSignupDialog',
	props: {
		dialogPromiseHandlers: { type: Object },
		installableId: { type: [String, Number] },
	},
	components: {
		AppDialog,
		InstallablePreview,
	},
	computed: {},
	methods: {
		close() {
			this.dialogPromiseHandlers?.resolve();
			this.$refs.dialog_container.closeCurrentDialog();
		},
		dismissInstallation() {
			this.close();
		},
		continueInstallation() {
			const currenRoute = this.$route;
			const newRoute = {
				...currenRoute,
				name: 'Installation' + currenRoute.name.replace('Installation', ''),
				params: { ...currenRoute.params, installableId: this.installableId },
				query: { ...currenRoute.query, return_to: encodeURI(`${process.env.VUE_APP_APP_URL}installation/${this.installableId}`) },
			};
			delete newRoute.path;
			this.$router.push(newRoute);
			this.close();
		},
	},
};
</script>

<style scoped lang="scss">
.content-container {
	width: 640px;
	max-height: 425px;
	min-height: 425px;
	overflow: hidden;
	border-radius: 10px;
	box-shadow: 0px 3px 6px var(--shadow-color);
	background: var(--setup-node-container-background);

	.title-text {
		font-size: 22px;
		font-weight: bold;
		color: var(--primary-font-color);
	}

	.title-description-text {
		font-size: 18px;
		color: var(--primary-font-color);
	}

	.dismiss-button {
		height: 45px;
		padding: 0px;
		width: 300px;
		font-size: 14px !important;
		color: var(--bold-border-color);
		background: var(--bg-color) !important;
		border: 1px solid var(--bold-border-color);
	}
	.divider-container {
		width: 300px;
		.divider {
			height: 1px;
			margin-top: 2px;
			background: #babdc4;
		}
		.divider-text {
			font-size: 14px;
			color: #babdc4;
		}
	}
	.continue-button {
		height: 45px;
		padding: 0px;
		width: 300px;
		font-size: 14px !important;
		color: var(--bg-color) !important;
		background: var(--bold-border-color);
		border: 1px solid var(--bold-border-color);
	}
}
</style>
